import React from "react";
import { toast } from "react-toastify";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    this.setState({ errorInfo });

    let safeString = "";

    try {
      safeString =
        typeof errorInfo === "string"
          ? errorInfo
          : JSON.stringify(errorInfo, null, 2);
    } catch (e) {
      safeString = String(errorInfo);
    }

    toast(`ERR: ${safeString}`);
    // You can also log this to an external service like Sentry here
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 bg-red-100 text-red-800 rounded-lg">
          <h2 className="text-xl font-bold">Something went wrong.</h2>
          <p>{this.state.error?.toString()}</p>
          <details className="whitespace-pre-wrap mt-2">
            {this.state.errorInfo?.componentStack}
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
